module.exports = __webpack_public_path__ + "img/vehicle-fitment.34842715.svg";